import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "contexts/authContext";
import UnauthorizedPage from "pages/UnauthorizedPage";

interface RoleRouteProps {
  allowedRoles: Array<string>;
}

const RoleRoute = ({ allowedRoles }: RoleRouteProps) => {
  const { currentUser, roles } = useAuth();

  if (!currentUser || !roles) {
    return <Navigate to="/login" />;
  }

  // Check if the user has one of the allowed roles
  const hasAllowedRole = roles.some(role => allowedRoles.includes(role));

  if (!hasAllowedRole) {
    return <UnauthorizedPage />;
  }

  return <Outlet />
};

export default RoleRoute;
